import React from "react"
import GeofenceDetails from "../components/Geofences/GeofenceDetails"

function GeofenceDetailPage() {
  return <GeofenceDetails />
}

export default GeofenceDetailPage
